import { FunctionComponent } from "react";
import { AccountTile, Button, tokens } from "@manifesthhqinc/ui-library";
import { OldAccountScreensProps } from "../useOldAccountDetails";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import Highlight from "../../../components/highlight";
import Footer from "../../../components/footer";
import HeadingContainer from "../../../layout/heading-container";
import { BodyLargeRegular, HeadlineMedium } from "../../../components/font";
import { AccountTilesContainer } from "./styles";

const ConfirmOldAccount: FunctionComponent<OldAccountScreensProps> = (props: OldAccountScreensProps) => {
  const {
    currentSourceAccountStep,
    currentOldAccountDetails,
    partnerConfig,
    onClickContinue,
    confirmedOldAccountDetails,
  } = props;

  return (
    <TransitionWrapper>
      <ScrollableContainer name={currentSourceAccountStep}>
        <Container>
          <HeadingContainer paneVariant="form" withProgressBar>
            <HeadlineMedium $textAlign="center">
              First, confirm the account to transfer
              <BodyLargeRegular $textAlign="center" $color={tokens.color.text.primary}>
                {partnerConfig ? (
                  <>
                    Thanks to <Highlight>{partnerConfig}</Highlight>, we already have your old plan details
                  </>
                ) : (
                  <>We already have your old plan details</>
                )}
              </BodyLargeRegular>
            </HeadlineMedium>
          </HeadingContainer>
          {confirmedOldAccountDetails.length > 0 ? (
            <AccountTilesContainer>
              {confirmedOldAccountDetails.map((e) => (
                <AccountTile
                  key={e.planSponsor}
                  title={e.planSponsor}
                  subtitle={
                    <>
                      <span>{e.planName}</span>
                      <br />
                      <span>{e.planNumber}</span>
                    </>
                  }
                  type="old-account"
                />
              ))}
            </AccountTilesContainer>
          ) : (
            <AccountTile
              title={currentOldAccountDetails.planSponsor}
              subtitle={
                <>
                  <span>{currentOldAccountDetails.planName}</span>
                  <br />
                  <span>{currentOldAccountDetails.planNumber}</span>
                </>
              }
              type="old-account"
            />
          )}
        </Container>
      </ScrollableContainer>
      <Footer>
        <Button name="continue" onClick={onClickContinue} size="large">
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default ConfirmOldAccount;
